import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../configApi";
const initialState = {
  isLoading: false,
  isNotify: false,
  isOpenModalGetLog: false,
  dataBanner: [],
  msg: "",
  typeNotify: "success",
  isError: false,
  isOpenModalAddBanner: false,
  isOpenModalEditBanner: false,
  isOpenModalDeleteBanner: false,
  lengthConfig: 0,
  numberBannerDefault: "",
  listChangeBanner: [],
  valueEdit: [],
  refetch: false,
  dataLog: [],
  config: {
    search: "",
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
};
const BannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    setOpenModalAddBanner: (state, action) => {
      state.isOpenModalAddBanner = action.payload;
    },
    resetStateBanner: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
    },
    setDataBanner: (state, action) => {
      state.dataBanner = action.payload;
    },
    setValueConfig: (state, action) => {
      state.config.search = action.payload.search;
      state.config.option.offset = action.payload.page
        ? action.payload.page
        : 1;
    },
    setDataSaveAll: (state, action) => {
      state.listChangeBanner = action.payload;
    },
    setOpenModalGetLogBanner: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
    setNumberDefault: (state, action) => {
      state.numberBannerDefault = action.payload;
    },
    setLenghtConfig: (state, action) => {
      state.lengthConfig = action.payload;
    },
    setOpenModalEditBanner: (state, action) => {
      state.isOpenModalEditBanner = action.payload.isOpen;
      state.valueEdit = action.payload.valueEdit;
    },
    resetState: (state) => {
      state.config = {
        search: "",
        option: {
          limit: 10,
          offset: 1,
          order: "desc",
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBanner.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(createBanner.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isLoading = false;
          state.isNotify = true;
          state.msg = "Thêm banner thành công.";
          state.isOpenModalAddBanner = false;
          state.refetch = true;
          state.typeNotify = "success";
        } else {
          state.isOpenModalAddBanner = true;
          state.msg = "Thêm banner thất bại";
          state.isLoading = false;
          state.isNotify = true;
          state.typeNotify = "error";
        }
      })
      .addCase(createBanner.rejected, (state) => {
        state.isOpenModalAddBanner = false;
        state.msg = "Thêm banner thất bại";
        state.isLoading = false;
        state.isNotify = true;
        state.typeNotify = "error";
      })
      // saveConfig
      .addCase(saveConfigBanner.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(saveConfigBanner.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isLoading = false;
          state.isNotify = true;
          state.msg = "Lưu thay đổi thành công.";
          state.isOpenModalAddBanner = false;
          state.typeNotify = "success";
        }
      })
      .addCase(saveConfigBanner.rejected, (state) => {
        state.msg = "Lưu thay đổi thất bại";
        state.isLoading = false;
        state.isNotify = true;
        state.typeNotify = "error";
      })
      // delete
      .addCase(deleteBanner.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isLoading = false;
          state.isNotify = true;
          state.refetch = true;
          state.msg = "Xóa banner thành công.";
          state.isOpenModalAddBanner = false;
          state.typeNotify = "success";
        }
      })
      .addCase(deleteBanner.rejected, (state) => {
        state.msg = "Xóa banner thất bại";
        state.isLoading = false;
        state.isNotify = true;
        state.typeNotify = "error";
      })
      // edit banner
      .addCase(editBanner.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(editBanner.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isLoading = false;
          state.isNotify = true;
          state.refetch = true;
          state.msg = "Chỉnh sửa banner thành công.";
          state.isOpenModalEditBanner = false;
          state.typeNotify = "success";
        }
      })
      .addCase(editBanner.rejected, (state) => {
        state.msg = "Chỉnh sửa banner thất bại";
        state.isLoading = false;
        state.isNotify = true;
        state.typeNotify = "error";
      })
      //save config
      .addCase(saveAllConfig.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(saveAllConfig.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isLoading = false;
          state.isNotify = true;
          state.refetch = true;
          state.msg = "Lưu cấu hình thành công.";
          state.isOpenModalAddBanner = false;
          state.typeNotify = "success";
        }
      })
      .addCase(saveAllConfig.rejected, (state) => {
        state.msg = "Xóa banner thất bại";
        state.isLoading = false;
        state.isNotify = true;
        state.typeNotify = "error";
      })

      //get banner
      .addCase(getBanner.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(getBanner.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isLoading = false;
          state.refetch = false;
          state.dataBanner = action.payload.data.data;
          state.numberBannerDefault = action.payload.data.configAds.find(
            (item) => item.name === "banner"
          ).number;
        }
      })
      .addCase(getBanner.rejected, (state) => {
        state.isLoading = false;
        state.isNotify = false;
        // state.typeNotify = "error";
      })
      //get log
      .addCase(getLogBanner.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(getLogBanner.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isLoading = false;
          state.dataLog = action.payload.data;
        }
      })
      .addCase(getLogBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isNotify = true;
        state.typeNotify = "error";
        // state.msg = action.payload;
      });
  },
});

export default BannerSlice;
export const {
  setOpenModalAddBanner,
  resetStateBanner,
  setDataBanner,
  setOpenModalGetLogBanner,
  setDataSaveAll,
  setNumberDefault,
  setLenghtConfig,
  setOpenModalEditBanner,
  resetState,
  setValueConfig,
} = BannerSlice.actions;

export const createBanner = createAsyncThunk(
  "banner/createBanner",
  async (data) => {
    try {
      const res = await instance.post(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/createBanner`,
        data,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      return res.data.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const saveConfigBanner = createAsyncThunk(
  "banner/saveConfigBanner",
  async (body) => {
    try {
      const res = await instance.post(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/saveConfig`,
        body,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      return res.data.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//delete
export const deleteBanner = createAsyncThunk(
  "banner/deleteBanner",
  async (id) => {
    try {
      const res = await instance.delete(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/deleteBanner/${id}`,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      return res.data.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const getBanner = createAsyncThunk(
  "banner/getBanner",
  async (options) => {
    try {
      const config = options
        ? options
        : {
            search: "",
            option: {
              limit: 10,
              offset: 1,
              order: "desc",
            },
          };
      const res = await instance.post(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/pageable`,
        config,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      return res.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//get log
export const getLogBanner = createAsyncThunk(
  "banner/getLogBanner",
  async (id) => {
    try {
      const res = await instance.get(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/getLog/${id}`,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
//save config
export const saveAllConfig = createAsyncThunk(
  "banner/saveAllConfig",
  async (body) => {
    try {
      const res = await instance.post(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/saveAll`,
        body,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      const result = res.data;
      return result.status;
    } catch (error) {
      console.log(error);
    }
  }
);

// edit
export const editBanner = createAsyncThunk(
  "banner/editBanner",
  async (body) => {
    console.log(body);
    try {
      const res = await instance.put(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/banner/editBanner`,
        body,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      const result = res.data;
      return result.status;
    } catch (error) {
      console.log(error);
    }
  }
);
